import React, { PureComponent } from 'react'
import Survey from 'app/Components/Survey'
import Form from 'app/Components/Survey/Panel/Form'

export default class FormPage extends PureComponent {
  render() {
    return (
      <div>
        <Survey>
          <Form />
        </Survey>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./survey/form/index.js
 **/